import SolutionIntegrationsI18n from "@/components/landing/shared/SolutionIntegrationsI18n";
const EcommerceIntegrationsSection = () => <SolutionIntegrationsI18n translationPrefix="ecommerceSolution" />;
export default EcommerceIntegrationsSection;
